(function($) {
    const toggleInstances = [];

    $.fn.setupToggle = function(options) {
        const defaults = {
            root: null,
            trigger: null,
            triggerOff: null,
            target: null,
            toggleClass: null,
            targetClass: 'on',
            exclusive: false,
            group: null,
            closeOutside: false
        };
        options = $.extend({}, defaults, options);

        return this.each(function() {
            const $toggle = $(this);
            const $root = options.root ? $(options.root) : $toggle;
            const $trigger = $toggle.find(options.trigger).first();
            const $target = $toggle.find(options.target).first();
            // const group = options.group || options.root || $toggle.selector || $toggle[0].id;
            const group = options.group || options.root;
            
            const $id = $toggle.prop('id') || 'toggle-'+Math.floor(Math.random() * 100);
            $toggle.prop('id', $id);
            // console.log($id);
            // console.log(options.root);

            $trigger.data('toggle', $toggle);
            $trigger.attr('tabindex', '0');
            // $trigger.attr('data-toggle', $id);


            const instance = {
                $id,
                $toggle,
                $root,
                $trigger,
                $target,
                group,
                options,
                isOn: false
            };
            toggleInstances.push(instance);

            // Delegate trigger events with closure
            // $root.on('click.togglePlugin', options.trigger, (function(currentInstance) {
            $root.on('click.togglePlugin', options.trigger, (function(currentInstance) {
                return function(e) {
                    
                    if(currentInstance.$toggle !== $(this).data('toggle')) {
                        return;
                        // console.log('ho 1');
                    } else {
                        e.preventDefault();
                        // console.log('ho 2');
                    }
                    
                    // console.log('ho 3');


                    if (currentInstance.isOn) {
                        toggleOff(currentInstance);
                    } else {
                        if (currentInstance.options.exclusive) {

                            toggleInstances.forEach(other => {
                                if (other !== currentInstance && 
                                    other.group === group && 
                                    !$.contains(other.$toggle[0], currentInstance.$toggle[0]) &&
                                    other.isOn &&
                                    1 == 1
                                ) {
                                        console.log('hit');

                                    toggleOff(other);
                                }
                            });
                        }
                        toggleOn(currentInstance);
                    }
                    
                };
            })(instance));

            // Delegate triggerOff events with closure
            if (options.triggerOff) {
                $root.on('click.togglePlugin', options.triggerOff, (function(currentInstance) {
                    return function(e) {
                        e.preventDefault();
                        if (currentInstance.isOn) toggleOff(currentInstance);
                    };
                })(instance));
            }
        });
    };

    $.fn.toggle = function() {
        return this.each(function() {
            const instance = toggleInstances.find(i => i.$toggle.is(this));
            if (instance) {
                instance.isOn ? toggleOff(instance) : toggleOn(instance);
            }
        });
    };

    function toggleOn(instance) {
        if (instance.options.toggleClass) instance.$toggle.addClass(instance.options.toggleClass);
        instance.$target.addClass(instance.options.targetClass);
        instance.$trigger.attr('aria-expanded', 'true');
        instance.isOn = true;
        if (instance.options.closeOutside) bindOutsideClick(instance);
    }

    function toggleOff(instance) {
        if (instance.options.toggleClass) instance.$toggle.removeClass(instance.options.toggleClass);
        instance.$target.removeClass(instance.options.targetClass);
        instance.$trigger.attr('aria-expanded', 'false');
        instance.isOn = false;
        if (instance.options.closeOutside) {
            console.log('unbind');
            unbindOutsideClick(instance)
        };
    }

    function bindOutsideClick(instance) {
        $(document).on('click.togglePluginOutside-'+instance.$id, function(e) {
            if (!instance.$target.is(e.target) && !instance.$target.has(e.target).length &&
                !instance.$trigger.is(e.target) && !instance.$trigger.has(e.target).length) {
                toggleOff(instance);
            }
        });
    }

    function unbindOutsideClick(instance) {
        $(document).off('click.togglePluginOutside-'+instance.$id);
    }

    /**
     * Sticky header on scroll up
     */
    function handleMastheadScroll() {
        let lastScrollTop = 0;
        const $masthead = $('#masthead');
        
        $(window).scroll(function() {
            let scrollPosition = $(this).scrollTop();

            /* Give it .scrolled class if beyond 200px threshold */

            if (scrollPosition >= 200) {
                $masthead.addClass('scrolled');
            } else {
                $masthead.removeClass('scrolled');
            }

            /* Give it .fixed class if scrolling up */
            if (scrollPosition < lastScrollTop) {
                /* Scrolling up */

                $masthead.addClass('fixed');

                if (scrollPosition < 200) {
                    $masthead.removeClass('scrolled');
                } else {
                    $masthead.addClass('scrolled');
                }
            } else {
                /* Scrolling down */
                
                $masthead.removeClass('fixed');

                // $masthead.removeClass('scrolled');

                if (scrollPosition === 0) {
                    $masthead.removeClass('scrolled');
                }
            }
            
            lastScrollTop = scrollPosition;
        });
    }


    // Example usage
    $(document).ready(function() {

        $('.site-navigation').setupToggle({
            trigger: '.menu-toggle-open',
            triggerOff: '.menu-toggle-close',
            target: '.menu-panel',
            targetClass: 'open',
            closeOutside: true
        });

        $('.menu-item-has-children').setupToggle({
            root: '#primary-menu',
            trigger: 'a',
            triggerOff: '.toggle.close',
            target: '.sub-panel',
            targetClass: 'open',
            toggleClass: 'open',
            closeOutside: true,
            exclusive: true
            // group: '#primary-menu'
        });

        $('.togglable').setupToggle({
            root: '#secondary-menu',
            trigger: 'a, .close', // Adjusted selector
            triggerOff: '.close', // Adjusted selector
            target: '.panel',
            targetClass: 'open',
            toggleClass: 'toggled',
            closeOutside: true,
            exclusive: true
        });

        // handleMastheadScroll();
    });
})(jQuery);